<template>
  <div
    v-if="product"
    class="sticky bottom-0 z-below-header w-full bg-white shadow-top "
    :style="`--un-bg-opacity: ${$viewport.lg ? '90%' : '100%'}; top: ${stickyHeaderTop}`"
  >
    <base-sticky :margin="0" name="stickyProductCta" position="bottom">
      <div
        ref="stickyContainerRef"
        class="flex items-center gap-4 p-4 lg:px-6 lg:py-2 "
        :class="{ wrap: showStickyTitle }"
        style="min-height: 4rem"
      >
        <base-picture
          v-if="stickyThumbnail?.src"
          :alt="stickyThumbnail.alt"
          class="h-16 shrink-0 <lg:hidden"
          :height="stickyHeader?.thumbnail.height"
          :props-img="{ class: 'w-a h-16' }"
          :src="stickyThumbnail.src"
          :width="stickyHeader?.thumbnail.width"
        />
        <div class="f-col gap-2 truncate <md:hidden">
          <p
            v-if="product && showStickyTitle"
            class="subtitle-3 lg:grow lg:subtitle-4 "
            data-test-id="product-name"
          >
            {{ product.name }}
          </p>
          <product-pricing
            v-if="productPrice"
            class="text-sm"
            :currency="product.currency"
            :price="productPrice"
          />
        </div>
        <div
          class="ml-a shrink-0 <md:w-full <md:flex <md:gap-1 <md:between"
          :class="{ 'flex items-center gap-1': showStickyCtaFavorites }"
        >
          <product-cta
            :add-to-cart-label="bundleAddToCartLabel"
            :attribute-selection="stickyCtaDisplay.attributeSelection"
            :class="showStickyCtaFavorites ? 'grow' : '<lg:w-full'"
            hide-strikethrough-price
            :include-coming-soon="$feature.showComingSoonOnPDP"
            :include-notify-me="$feature.showNotifyMeOnPDP"
            :include-price="$feature.showPriceInCtas && !$viewport.lg"
            :include-reserve-in-store="$feature.allowProductReservationOnPDP"
            :include-select-size="$feature.showSelectSizeOnPDP"
            :loading="addToCartLoading"
            :pending="variantRequestPending"
            :product="stickyCtaDisplay.product"
            style="min-width: 12.5rem"
            @add-to-cart="handleAddToCart"
            @notify-me="handleNotifyMe"
            @reserve-in-store="handleInStore('reserve')"
          />
          <product-cta-favorites
            v-if="showStickyCtaFavorites && showFavorites"
            :is-favorite
            :pending="isFavoritePending"
            @add="addFavorite"
            @remove="removeFavorite"
          />
        </div>
      </div>
    </base-sticky>
  </div>
</template>

<script lang="ts" setup>
const { showStickyCtaFavorites, showStickyHeader, stickyHeader } = useAppConfig().pages.pdp
const header = useHeaderStore()
const { $feature, $viewport } = useNuxtApp()
const {
  addFavorite,
  addToCartLoading,
  bundleAddToCartLabel,
  galleryItems,
  handleAddToCart,
  handleNotifyMe,
  handleInStore,
  isFavorite,
  isFavoritePending,
  product,
  productPrice,
  removeFavorite,
  stickyCtaDisplay,
  showFavorites,
  variantRequestPending
} = usePdp()
const stickyState = useSticky()
const { height: windowHeight } = useWindowSize()

const stickyContainerRef = ref<HTMLElement>()

const { top: productDetailsCtaTop } = useElementBounding(() => stickyState.value.productDetailsCta)
const { y: productTitleY } = useElementBounding(useState('productDetailsTitleRef'))
const { height: stickyContainerHeight } = useElementBounding(stickyContainerRef)

const stickyThumbnail = computed(() => galleryItems.value.find((item) => item.type !== 'espot'))

const showStickyTitle = computed(() =>
  $viewport.lg || ($viewport.sm && productTitleY.value > (windowHeight.value - stickyContainerHeight.value))
)

const stickyHeaderTop = computed(() =>
  !showStickyHeader && !header.pageScrolledUp
    ? '0'
    : productDetailsCtaTop.value < 0 && !header.pageScrolledUp
      ? pxToRem(header.sticky.offset)
      : pxToRem(header.sticky.margin)
)
</script>
